export type RoundTypeResponseBody = {
  key: string;
  value: string;
};

export type GetRoundTypeApiResponse = /** status 200  */ RoundTypeResponseBody[];
export type GetRoundTypeApiArg = void;
